document.addEventListener('DOMContentLoaded', () => {
  const apiKey = '45b0ebbf3633b07580988f0dc28ad670d49f79d9c2f16d2486de2eeb';
  const apiUrl = `https://api.ipdata.co?api-key=${apiKey}`;
  const currentDomain = window.location.hostname;
  const marketsItems = document.querySelectorAll('.currency-switcher li');
  const countriesList = document.querySelectorAll('.country-items li');

  const domainConditions = [
    {
      country: 'eu',
      domain: 'www.joloves.com',
      desc: 'You are currently browsing our United Kingdom store. Would you like to switch to Europe?',
      buttonText: 'Go to Europe Store',
    },
    {
      country: 'eu',
      domain: 'us',
      desc: 'You are currently browsing our United States store. Would you like to switch to Europe?',
      buttonText: 'Go to Europe Store',
    },
    {
      country: 'uk',
      domain: 'us',
      desc: 'You are currently browsing our United States store. Would you like to switch to United Kingdom?',
      buttonText: 'Go to United Kingdom Store',
    },
    {
      country: 'uk',
      domain: 'eu',
      desc: 'You are currently browsing our Europe store. Would you like to switch to United Kingdom?',
      buttonText: 'Go to United Kingdom Store',
    },
    {
      country: 'us',
      domain: 'www.joloves.com',
      desc: 'You are currently browsing our United Kingdom store. Would you like to switch to United States?',
      buttonText: 'Go to United States Store',
    },
    {
      country: 'us',
      domain: 'eu',
      desc: 'You are currently browsing our Europe store. Would you like to switch to United States?',
      buttonText: 'Go to United States Store',
    },
    {
      country: 'non',
      domain: 'us',
      desc: 'You are currently browsing our United States. Would you like to switch to Europe?',
      buttonText: 'Go to Europe Store',
    },
    {
      country: 'non',
      domain: 'www.joloves.com',
      desc: 'You are currently browsing our United Kingdoms. Would you like to switch to Europe?',
      buttonText: 'Go to Europe Store',
    },
  ];

  const fetchJson = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const addClasses = (element, ...classes) => {
    element.classList.add(...classes);
  };

  const handleItemClick = (event) => {
    const switcherHead = document.querySelector('.popup-head');
    const switcherDesc = document.querySelector('.popup-desc');
    const confirmationSwitcherButton = document.querySelector('.confirmation-button');
    const closeSwitcherButton = document.querySelector('.close-switcher');
    const countryLink = event.currentTarget.getAttribute('data-market-link');
    const confirmationButton = document.querySelector('#switcher-modal a');

    switcherHead.classList.add('hidden');
    switcherDesc.textContent =
      'When switching countries your shopping bag will be emptied. Are you sure you want to proceed?';
    confirmationSwitcherButton.textContent = 'Continue';
    closeSwitcherButton.textContent = 'Cancel';
    confirmationButton.href = countryLink;
  };

  const updateMarketItems = (currentCountryMarketLink, isNonShipping) => {
    marketsItems.forEach((marketItem) => {
      const marketLink = marketItem.getAttribute('data-market-link');
      const marketName = marketItem.getAttribute('data-market-name');
      const marketShippingStatus = marketItem.getAttribute('data-market-shipping-status');

      const dropdowns = marketItem.querySelectorAll('.dropdown');

      dropdowns.forEach((dropdown) => {
        dropdown.classList.add('hidden');
      });

      if (isNonShipping) {
        const dropdown = marketItem.querySelector('.dropdown');

        if (marketName === 'Rest of the world') {
          addClasses(
            marketItem,
            'active',
            'md:text-body-sm',
            'top-0',
            'z-20',
            'sticky',
            'group-[.active]/currency-switcher--ul:block',
            'group-[.active]/currency-switcher--ul:bg-grey-0',
            '-order-1',
            'current'
          );
          if (dropdown) dropdown.classList.remove('hidden');
        } else {
          addClasses(marketItem, 'relative', 'hidden', 'bg-grey-0', 'group-[.active]/--ul:block', 'hover:bg-grey-150');
          if (dropdown) dropdown.classList.add('hidden');
        }
      } else {
        const dropdown = marketItem.querySelector('.dropdown');
        if (marketLink === currentCountryMarketLink && marketShippingStatus === 'true') {
          if (dropdown) dropdown.classList.remove('hidden');

          addClasses(
            marketItem,
            'active',
            'md:text-body-sm',
            'top-0',
            'z-20',
            'sticky',
            'group-[.active]/currency-switcher--ul:block',
            'group-[.active]/currency-switcher--ul:bg-grey-0',
            '-order-1',
            'current'
          );
        } else {
          if (dropdown) dropdown.classList.add('hidden');

          addClasses(
            marketItem,
            'relative',
            'hidden',
            'bg-grey-0',
            'group-[.active]/currency-switcher--ul:block',
            'hover:bg-grey-150'
          );
        }
      }

      marketItem.addEventListener('click', handleItemClick);
    });
  };

  const checkDomainCondition = (currentCountryMarketLink) => {
    const matchedCondition = domainConditions.find(
      (condition) => currentCountryMarketLink.includes(condition.country) && currentDomain.includes(condition.domain)
    );

    const switcherHead = document.querySelector('.popup-head');
    const switcherDesc = document.querySelector('.popup-desc');
    const confirmationSwitcherButton = document.querySelector('.confirmation-button');
    const closeSwitcherButton = document.querySelector('.close-switcher');
    const switcherModal = document.getElementById('switcher-modal');

    if (matchedCondition) {
      switcherHead.classList.remove('hidden');
      switcherDesc.textContent = matchedCondition.desc;
      confirmationSwitcherButton.textContent = matchedCondition.buttonText;
      confirmationSwitcherButton.href = currentCountryMarketLink;
      closeSwitcherButton.textContent = 'Continue Browsing';

      if (sessionStorage.getItem('country-switcher-closed') !== 'true') {
        switcherModal.classList.remove('hidden');
        switcherModal.classList.add('flex');

        closeSwitcherButton.addEventListener('click', () => {
          switcherModal.classList.add('hidden');
          switcherModal.classList.remove('flex');
          sessionStorage.setItem('country-switcher-closed', 'true');
        });
      }
    }
  };

  fetchJson(apiUrl).then((data) => {
    if (!data) return;
    const currentLocationCode = data.country_code.toLowerCase();
    let locationFound = false;

    countriesList.forEach((item) => {
      const countryCode = item.getAttribute('data-country-code').toLowerCase();
      let currentCountryMarketLink = item.getAttribute('data-country-link');

      // Remove 'staging-' prefix if it exists
      currentCountryMarketLink = currentCountryMarketLink.replace(/^https?:\/\/staging-/, 'https://');

      if (countryCode === currentLocationCode) {
        locationFound = true;
        if (currentDomain.includes('www.joloves.com')) {
          updateMarketItems('https://joloves.com/', false);
        } else if (currentDomain.includes('us')) {
          updateMarketItems('https://us.joloves.com/', false);
        } else {
          updateMarketItems('https://eu.joloves.com/', false);
        }
        checkDomainCondition(currentCountryMarketLink);
      }
    });

    if (!locationFound) {
      let defaultLink = 'https://eu.joloves.com/';
      if (currentDomain.includes('www.joloves.com')) {
        defaultLink = 'https://joloves.com/';
      } else if (currentDomain.includes('us')) {
        defaultLink = 'https://us.joloves.com/';
      }

      updateMarketItems(defaultLink, currentDomain.includes('eu'));
      checkDomainCondition(defaultLink);
    }
  });
});
